/**
 * 402 Insufficient Credits handler.
 *
 * Install once at app root. When any API call returns 402, emits a custom
 * DOM event that a global toast listener can pick up.
 */

export const INSUFFICIENT_CREDITS_EVENT = "payment:insufficient-credits";

export interface InsufficientCreditsDetail {
  required?: number;
  available?: number;
}

export function dispatchInsufficientCredits(detail: InsufficientCreditsDetail) {
  window.dispatchEvent(
    new CustomEvent<InsufficientCreditsDetail>(INSUFFICIENT_CREDITS_EVENT, {
      detail,
      bubbles: false,
    })
  );
}

export function handleInsufficientCreditsResponse(responseBody: unknown): boolean {
  if (
    typeof responseBody === "object" &&
    responseBody !== null &&
    "code" in responseBody &&
    (responseBody as { code: string }).code === "insufficient_credits"
  ) {
    const body = responseBody as Record<string, unknown>;
    dispatchInsufficientCredits({
      required:
        typeof body.required === "number"
          ? body.required
          : typeof body.requiredCents === "number"
            ? body.requiredCents
            : undefined,
      available:
        typeof body.available === "number"
          ? body.available
          : typeof body.availableCents === "number"
            ? body.availableCents
            : undefined,
    });
    return true;
  }
  return false;
}
